module.exports = __webpack_public_path__ + "img/aclists(12).4960d054.png";